var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LinkStyles } from './LinkStyles';
export var Link = function (_a) {
    var href = _a.href, text = _a.text, onClick = _a.onClick, dataCy = _a.dataCy;
    return (_jsx(LinkStyles, __assign({ href: href || '', target: "_blank", rel: "noreferrer", "data-cy": dataCy, onClick: function (e) {
            if (onClick) {
                e.preventDefault();
                onClick();
            }
        } }, { children: text })));
};
